import parsePhoneNumber from "libphonenumber-js";

export default (number) => {
  const phoneNumber = parsePhoneNumber(`+${number.replace(/^\+/, "")}`);

  return phoneNumber
    ? `${phoneNumber.countryCallingCode}${phoneNumber.nationalNumber}`
    : number.replace(/[^0-9]/g, "");
};
